import React from 'react';
import { m } from 'framer-motion';
import { socialStats } from '../../data/socialProof';
export function SocialProof() {
  return <section className="border-y border-gris-claro bg-bg-secondary py-10 sm:py-12" data-id="element-199" data-mp="i3xl3iirj7aw">
      <div className="mx-auto max-w-5xl px-6 sm:px-8" data-id="element-200" data-mp="dbe9gr3mym8q">
        <div className="grid grid-cols-2 gap-x-6 gap-y-8 lg:grid-cols-4" data-id="element-201" data-mp="8dm5uztmpbop">
          {socialStats.map((stat, i) => <m.div key={stat.label} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-col items-center gap-2 text-center" data-id="element-202" data-mp="3f16t3q44y1u" data-mpi={i}>
              <stat.icon size={22} className={stat.colorClass} data-id="element-203" data-mp="3llp96lts373t" />
              <p className={`font-heading text-2xl font-bold sm:text-[32px] ${stat.colorClass}`} data-id="element-204" data-mp="1osdz1eylmmz2">{stat.value}</p>
              <p className="text-sm text-gris-texto" data-id="element-205" data-mp="1jtsz7gn9e5b5">{stat.label}</p>
            </m.div>)}
        </div>
      </div>
    </section>;
}